<script>
import util from "@/libs/util";
import { validatePass,validatePhoneNumber,validateEmail } from "@/common/validate";

export default {
  name: "set_mobile_page",
  data() {
    // 验证 不同的验证方式 手机号有手机号的规则 邮箱有邮箱的规则
    const validateValidateWay = (rule, value, callback)=>{
      if (!value) {
        callback(new Error(this.$t("l."+(this.radio.value == "1"?"remark3":"remark03"))));
      } else {
        if(this.radio.value == "1"){   // 手机号
          if(!validatePhoneNumber(value)){
            callback(new Error(this.$t("l.remark91")));
          }else{
            callback();
          }
        }else{    //  邮箱
          console.log("验证邮箱");
          if(!validateEmail(value)){
            callback(new Error(this.$t("l.remark14")));
          }else{
            callback();
          }
        }
      }
    }
    return {
      form: {
        mobile: "",
        captcha: "",
        username: "",
        password: "",
        again_password:"",
      },
      radio:{
        value:"1",
        validateWay:'mobile'
      },
      start: this.$t('l.get_captcha'),
      isVerificationShow: false,
      puzzleSpin:false,
      isVerificationShowForSubmit:false,
      loading:false,
      puzzleImgList: [
        "/images/banner/banner1.jpg",
        "/images/banner/banner3.jpg",
      ],
      rules: {
        mobile: [
          {validator: validateValidateWay, trigger: 'blur', required: true}
        ],
        captcha: [
          {required: true, message: '验证码必填', trigger: 'blur'}
        ],
        username: [
          {required: true, message: '用户名必填', trigger: 'blur'}
        ],
        password: [
          {validator: validatePass, trigger: 'blur', required: true}
        ],
        again_password: [
          {validator: validatePass, trigger: 'blur', required: true}
        ],
        // oldpassword:[
        //   {required: true, message: '原密码必填', trigger: 'blur'}
        // ]
      },
      showPwdContent:false,
      passwordType:"password"
    }
  },
  methods: {
    getCaptcha() {
      // 需要验证是否是人
      if (!this.form.mobile) {
        this.$Message.error(this.$t('l.remark3'))
        return
      }
      this.isVerificationShow = true;
    },
    handleSuccess() {
      this.puzzleSpin = true;
      util.ajax.get('/captcha', {
        params: {
          data: {
            company: "【" + this.$t('l.dty_platform') + "】",
            mobile: this.form.mobile,
            type:this.radio.value,
            language: localStorage.getItem('language')
          }
        }
      }).then(res => {
        this.puzzleSpin = false;
        this.isVerificationShow = false;
        if (!res.code) {
          this.start = 60;
          this.$Message.success(this.$t('l.hint4'));
          var timer = setInterval(() => {
            if (this.start == 0) {
              clearInterval(timer)
              this.start = this.$t('l.get_captcha');
            } else {
              this.start--;
            }
          }, 1000)
        }
      })
    },

    // 提交
    handleSuccessForSubmit(){
      this.isVerificationShowForSubmit = false;
      util.ajax.post('/perfectMobile', {
        mobile:this.form.mobile,
        type:this.radio.value,
        captcha:this.form.captcha,
      }).then((res) => {
        if(!res.code){
          this.$Message.success({
            top: 50,
            duration: 2,
            content:"操作成功"
          });
          this.$router.push({
            name: 'home_index'
          });
        }
      }).catch(e => {
      }).finally(()=>{
        this.loading = false;
      });
    },

    handleOnError() {
      this.$Message.error("验证失败，请重试")
    },
    changeShowPwd() {
      this.showPwdContent = !this.showPwdContent;
      this.passwordType = this.showPwdContent ?"text":"password";
    },

    // 提交表单
    submit(){
      // 验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.isVerificationShowForSubmit = true;
          this.handleSuccessForSubmit();
        }
      });
    },

    // 返回登录
    backLogin(){
      localStorage.clear();
      this.$router.push({
        name: 'login'
      })
    },
    changeRadio(val){
      this.form.mobile = "";
    }


  },
  mounted() {
    util.ajax.get('/getuser', {params: {refresh:  0}}).then((res) => {
      let user = res.data;
      if (user){
        console.log(user);
        this.form.username =  user.username;
      }
    }).catch(err => {

    });
  }
}
</script>

<template>
  <div class="container">
    <Row class="form-con-row" type="flex" justify="center">
      <Col>
        <!-- 重设密码 -->
        <h2 style="margin-top: 5vh">您好，为了更好的服务平台用户，需要对手机号进行正确绑定，请在此页面完善您的手机号信息。</h2>
      </Col>
    </Row>
    <div class="login-con">
      <div class="form-con">
        <template>
          <Row class="form-con-row" type="flex" justify="center" style="margin-top: 20px">
            <Col>
              <Form :rules="rules" label-position="top" ref="form" :model="form"
                    class="form-con-form forget-form">
                <FormItem label="手机号" prop="mobile" class="FormItem">
                      <Input class="form-input" type="text" v-model="form.mobile" autocomplete="off" placeholder="请输入手机号"/>
                </FormItem>
                <FormItem :label="$t('l.captcha')" prop="captcha" class="FormItem">
                  <div class="form-con-form-div">
                    <Row :gutter="10">
                      <Col span="6">
                        <Input class="input-captcha" type="text" v-model="form.captcha" autocomplete="off" :placeholder="$t('l.remark4')"/>
                      </Col>
                      <Col span="4">
                        <Button :style="{backgroundColor:start!=$t('l.get_captcha')?'#aaa':'#5e30c3'}"
                                :disabled="start!=$t('l.get_captcha') || isVerificationShow"  class="button-captcha" type="info"
                                long @click="getCaptcha">{{ start }}
                        </Button>
                      </Col>
                      <Col span="14">
                        <span style="font-size: 12px;color: red;margin-left: 10px">* {{$t("l.remark239")}}</span>
                      </Col>
                    </Row>
                  </div>
                </FormItem>
              </Form>

            </Col>
          </Row>
        </template>
        <Row type="flex" justify="center" style="padding: 10px 20px;margin-top: 20px">
          <Col>
            <Button type="primary" :loading="loading" :disabled="loading || isVerificationShowForSubmit" @click="submit">提交</Button>
            <Button type="primary" class="margin-left-10" @click="backLogin">返回登录</Button>
          </Col>
        </Row>
      </div>
    </div>
    <div class="puzzle-box">
      <puzzleVerification :puzzleImgList="puzzleImgList" v-model="isVerificationShow" :onSuccess="handleSuccess"
                          :on-error="handleOnError" blockType="puzzle"></puzzleVerification>
    </div>
    <Spin fix v-if="puzzleSpin" style="z-index: 999999" class="full"></Spin>
  </div>
</template>

<style scoped lang="less">
.container{
  padding: 0 10px;
  height: 100%;
}

.puzzle-box {
  position: relative;
  z-index: 8888;
  display: flex;
  justify-content: center;
  bottom: 35vh;
}

.form-con {
  margin: 40px 0;
}
</style>